import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 bg-red-50 border-y border-red-100 px-4" data-id="element-274">
      <div className="max-w-3xl mx-auto text-center" data-id="element-275">
        <div className="flex justify-center mb-4" data-id="element-276">
          <ClockIcon className="w-12 h-12 text-red-600 animate-pulse" data-id="element-277" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-red-700 mb-4" data-id="element-278">
          Questa offerta speciale non resterà disponibile a lungo
        </h2>
        <p className="text-lg text-stone-700 mb-8" data-id="element-279">
          Per un periodo limitato puoi accedere al Metodo Completo per
          Insegnanti di Tango con uno sconto straordinario. Dopo la scadenza del
          timer, il prezzo potrebbe aumentare.
        </p>
        <div className="flex justify-center scale-110 md:scale-125 origin-top" data-id="element-280">
          <CountdownTimer variant="dark" data-id="element-281" />
        </div>
      </div>
    </section>;
}